import { render, staticRenderFns } from "./relation-tabs.vue?vue&type=template&id=64a01578&scoped=true&"
import script from "./relation-tabs.vue?vue&type=script&lang=js&"
export * from "./relation-tabs.vue?vue&type=script&lang=js&"
import style0 from "./relation-tabs.vue?vue&type=style&index=0&id=64a01578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a01578",
  null
  
)

export default component.exports